var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isChildRoot)?_c('dash-page-new',{attrs:{"title":_vm.$t('Template'),"side-navigation":_vm.avalonAdminTemplateNavigationItems,"navigation-return-route":_vm.localeLink('avalon_editor/templates')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }